import { createRef, PureComponent } from 'react';
import { string, func } from 'prop-types';
import * as classNames from './CountdownTimer.module.css';
import { Timer } from '@fff-web/fff-utilities';

class CountdownTimer extends PureComponent {
  state = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };

  timerIntervalRef = createRef(0);

  componentDidMount() {
    this.setTimer(this.props.openDate);
  }

  setTimer = (openDate) => {
    this.timerIntervalRef.current = setInterval(() => {
      const timeLeft = Timer.getTimeLeft(openDate);
      if (timeLeft.timeUp) {
        clearInterval(this.timerIntervalRef.current);
        this.props.timerRefresh();
      } else {
        this.setState(timeLeft);
      }
    }, 1000);
  };

  componentWillUnmount() {
    clearInterval(this.timerIntervalRef.current);
  }

  render() {
    const { days, hours, minutes, seconds } = this.state;
    return (
      <div className={classNames.timer}>
        <p className={classNames.timerHeader}>CUSTOMIZATION OPENS IN</p>
        <div className={classNames.timeContainer}>
          <div className={classNames.timeBlock}>
            <h5>{days}</h5>
            <p>DAYS</p>
          </div>
          <div className={classNames.colon}>:</div>
          <div className={classNames.timeBlock}>
            <h5>{hours}</h5>
            <p>HRS</p>
          </div>
          <div className={classNames.colon}>:</div>
          <div className={classNames.timeBlock}>
            <h5>{minutes}</h5>
            <p>MIN</p>
          </div>
          <div className={classNames.colon}>:</div>
          <div className={classNames.timeBlock}>
            <h5>{seconds}</h5>
            <p>SEC</p>
          </div>
        </div>
      </div>
    );
  }
}

export default CountdownTimer;

CountdownTimer.propTypes = {
  openDate: string,
  timerRefresh: func,
};

CountdownTimer.defaultProps = {
  openDate: '2020-01-04T21:19:00Z',
  timerRefresh: () => {},
};
